import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../../environment/environment';
import { normalizeHttpValue, shakeParams } from '@common/params';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  readonly #baseUrl = `${environment.API_URL}/v1`;
  readonly #http = inject(HttpClient);

  public get<T>(url: string, params: any = {}): Observable<T> {
    params = shakeParams(params);
    return this.#http
      .get<T>(`${this.#baseUrl}${url}`, {
        params,
      })
      .pipe(
        catchError(error => {
          console.error('Error fetching data:', error);
          return throwError(() => error);
        })
      );
  }

  public post<T>(url: string, data: any, params: any = {}, headers: any = {}): Observable<T> {
    data = normalizeHttpValue(data);
    params = shakeParams(params);

    return this.#http
      .post<T>(`${this.#baseUrl}${url}`, data, {
        params,
        headers,
      })
      .pipe(
        catchError(error => {
          console.error('Error posting data:', error);
          return throwError(() => error);
        })
      );
  }
}
